import DeviceManagement from "./DeviceManagement";

export default DeviceManagement;